import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { Container, Header, ListRow, RowLeft, TextLines, RowRight } from './ShimmerList.styles';
import { ShimmerListProps } from './ShimmerList.types';

const skeletonProps = {
  baseColor: '#ebebeb',
  highlightColor: '#f5f5f5'
};

const ShimmerListRow = ({
  showBadge,
  avatarShape
}: {
  showBadge: boolean;
  avatarShape: 'circle' | 'square';
}) => (
  <ListRow>
    <RowLeft>
      <Skeleton
        circle={avatarShape === 'circle'}
        width={48}
        height={48}
        borderRadius={avatarShape === 'square' ? 8 : undefined}
        {...skeletonProps}
      />
      <TextLines>
        <Skeleton width={140} height={14} {...skeletonProps} />
        <Skeleton width={100} height={12} {...skeletonProps} />
      </TextLines>
    </RowLeft>
    <RowRight>
      <Skeleton width={80} height={14} {...skeletonProps} />
      {showBadge && <Skeleton width={70} height={20} borderRadius={10} {...skeletonProps} />}
    </RowRight>
  </ListRow>
);

export const ShimmerList = ({
  count = 5,
  showHeader = false,
  showBadge = true,
  avatarShape = 'circle',
  width,
  height
}: ShimmerListProps) => {
  return (
    <Container $width={width} $height={height}>
      {showHeader && (
        <Header>
          <Skeleton width={120} height={18} {...skeletonProps} />
          <Skeleton width={24} height={24} {...skeletonProps} />
        </Header>
      )}
      {Array.from({ length: count }).map((_, i) => (
        <ShimmerListRow key={i} showBadge={showBadge} avatarShape={avatarShape} />
      ))}
    </Container>
  );
};
